import Repository from './Repository'

const resource = '/lib'

export default {
  get(nameLib, config = {}) {
    return Repository.get(resource + nameLib, config)
  },
  post(nameLib, config = {}) {
    return Repository.post(resource + nameLib, config)
  },
  request(config) {
    return Repository.request(config)
  },
}
